import { useQuery } from '@tanstack/react-query';
import { useApi } from 'contexts/ApiContext';

import type api from 'api';
import type { QueryOptionsFor } from 'hooks/api/types';
import useProjectRoute from 'hooks/useProjectRoute';

interface Params {
  deploymentId: string | null | undefined;
  options?: QueryOptionsFor<typeof api.getDeploymentProjection>;
}

export const useDeploymentState = ({ deploymentId, options }: Params) => {
  const api = useApi();
  const { accountId, projectId } = useProjectRoute();
  const queryKey = [
    'deployments',
    accountId,
    projectId,
    'state',
    deploymentId!,
    'stream',
  ];

  return useQuery({
    queryKey,
    queryFn: () =>
      api.methods.getDeploymentProjection({
        accountId,
        projectId,
        deploymentId: deploymentId!,
      }),
    cacheTime: 0,
    ...options,
    enabled: !!deploymentId && (options?.enabled ?? true),
  });
};
